<h3 class="top-padding"> 培訓記錄 </h3>

<div style="text-align: left;">
  <a routerLink="../">返回</a>
</div>
<hr>

<ng-container *ngFor="let record of record$ | async">
  <!-- <div class="col-md-4"> -->
  <div class='homeCard' routerLink="/training/training-record/{{record['id']}}">
    <h3 class="title"> {{ record['name'] }}</h3>
  </div>

  <!-- </div> -->
</ng-container>
